import { CustomLoader } from '@components/CustomLoader';
import { PageContainer } from '@components/PageContainer';
import { useAdminOrganization } from '@features/admin/api/getAdminOrganization';
import { useSelectedAdminOrganization } from '@features/admin/useSelectedAdminOrganization';
import { useLogPageView } from '@features/analytics/hooks/useLogPageView';
import { createFileRoute, Navigate, Outlet, useLocation } from '@tanstack/react-router';
import type { CSSProperties } from 'react';
import { useEffect } from 'react';

const HTTP_STATUS_FORBIDDEN = 403;
const LOADER_STYLE = { '--loader-size': '58px' } as CSSProperties;

const AdminContainer = () => {
  useLogPageView(useLocation({ select: (location) => location.pathname }));
  const { data: adminOrg, isLoading, error } = useAdminOrganization();
  const { organizationId, setOrganizationId } = useSelectedAdminOrganization();
  const hasStaleSelection = error?.response?.status === HTTP_STATUS_FORBIDDEN && organizationId !== null;

  // A remembered organization the user no longer administers is a 403; drop it and refetch the default.
  useEffect(() => {
    if (hasStaleSelection) {
      setOrganizationId(null);
    }
  }, [hasStaleSelection, setOrganizationId]);

  if (isLoading || hasStaleSelection) {
    return (
      <PageContainer>
        <CustomLoader style={LOADER_STYLE} />
      </PageContainer>
    );
  }

  if (!adminOrg) {
    return <Navigate to='/' />;
  }

  return <Outlet />;
};

export const Route = createFileRoute('/_authenticated/_shell/admin')({ component: AdminContainer });
